
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Draw borders`}</h2>
    <Playground mdxType="Playground">
  <div className="demo-item ecl-u-border-all">.ecl-u-border-all</div>
  <div className="demo-item ecl-u-border-top">.ecl-u-border-top</div>
  <div className="demo-item ecl-u-border-right">.ecl-u-border-right</div>
  <div className="demo-item ecl-u-border-bottom">.ecl-u-border-bottom</div>
  <div className="demo-item ecl-u-border-left">.ecl-u-border-left</div>
    </Playground>
    <h2>{`Border width`}</h2>
    <Playground mdxType="Playground">
  <div className="demo-item ecl-u-border-all ecl-u-border-width-1">
    .ecl-u-border-width-1
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2">
    .ecl-u-border-width-2
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-4">
    .ecl-u-border-width-4
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-8">
    .ecl-u-border-width-8
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-0">
    .ecl-u-border-width-0
  </div>
    </Playground>
    <h2>{`Border colour`}</h2>
    <p>{`Note: this list is not exhaustive, please read the usage page to know available colours.`}</p>
    <Playground mdxType="Playground">
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2 ecl-u-border-color-grey">
    .ecl-u-border-color-grey
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2 ecl-u-border-color-blue">
    .ecl-u-border-color-blue
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2 ecl-u-border-color-yellow">
    .ecl-u-border-color-yellow
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2 ecl-u-border-color-red">
    .ecl-u-border-color-red
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-width-2 ecl-u-border-color-grey-20">
    .ecl-u-border-color-grey-20
  </div>
    </Playground>
    <h2>{`Border style`}</h2>
    <Playground mdxType="Playground">
  <div className="demo-item ecl-u-border-all ecl-u-border-style-solid">
    .ecl-u-border-style-solid
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-style-dashed">
    .ecl-u-border-style-dashed
  </div>
  <div className="demo-item ecl-u-border-all ecl-u-border-style-dotted">
    .ecl-u-border-style-dotted
  </div>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;